import "../../nzComponent.css";
import VideoSchema from "../../../schema/VideoSchema";

const NZYouTube = () => {
  return (
    <div className="bg-[#f1f1f1]">
      <VideoSchema
        title="Why Tuatara Stands Apart - ATV vs UTV differences"
        description="Geoff Hill from Tuatara ATV explains what makes the eTuatara different from a typical ATV or side-by-side utility vehicle. Watch to see how electric performance and heavy-duty design come together in a machine built for New Zealand conditions."
        thumbnailUrl="https://img.youtube.com/vi/OAkhAEYyw5g/hqdefault.jpg"
        uploadDate="2023-01-01"
        duration="PT1M58S"
        contentUrl="https://www.youtube.com/embed/OAkhAEYyw5g"
        embedUrl="https://www.youtube.com/embed/OAkhAEYyw5g?si=ygwxx6qAodMlxfhh"
      />
      <div className="pt-[86px] pb-[65px] bg-[#f1f1f1] nz-you-tube-bg">
        <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
          <div className="custom-container px-[30px] text-center">
            <h2 className="kuunari-bold 2xl:text-[70px] lg:text-[66px] md:text-[55px] text-[55px] font-semibold	lg:mb-[60px] sm:mb-[20px] text-[#383838] leading-[1em] mb-[10px]">
              Why Tuatara Stands Apart
            </h2>

            <div className="text-center flex items-center justify-center max-w-[821px] mx-auto">
              <iframe
                width="70%100%"
                height="447px"
                src="https://www.youtube.com/embed/OAkhAEYyw5g?si=ygwxx6qAodMlxfhh"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>

            <p className="text-center text-[#A8A6A6] text-[20px]  leading-[1.8em] montserrat-medium pt-[30px] pb-[30px]">
              Geoff Hill from Tuatara ATV explains what makes the eTuatara different from a typical ATV or side-by-side utility vehicle. Watch to see how electric performance and heavy-duty design come together in a machine built for New Zealand conditions.
            </p>

            <h2 className="text-center text-[#383838] text-[30px] leading-[68px] pt-[3px] pb-[13px] kuunari-bold uppercase">
              ATV? UTV? Side-by-side? What’s the difference?
            </h2>
            <p className="text-center text-[#A8A6A6] text-[20px]  leading-[1.8em] montserrat-medium">
              Many machines are grouped under the term “ATV”, but not all are built the same. Understanding the difference between a traditional ATV and a side-by-side UTV helps clarify where Tuatara fits, and why it’s designed for heavier workloads.
            </p>
            <div className="mt-[30px] overflow-x-auto">
              <table className="w-full border border-[#bfbfbf] border-collapse text-[15px] text-[#000]">
                <thead>
                  <tr>
                    <th className="border border-[#bfbfbf] p-[10px] font-semibold text-center">
                      Feature
                    </th>
                    <th className="border border-[#bfbfbf] p-[10px] font-semibold text-center">
                      ATV (All-Terrain Vehicle)
                    </th>
                    <th className="border border-[#bfbfbf] p-[10px] font-semibold text-center">
                      UTV (Off-Road Utility Vehicle)
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">Seating</td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Single rider (typically)
                    </td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      2–4 passengers, side-by-side seating
                    </td>
                  </tr>

                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">Steering</td>
                    <td className="border border-[#bfbfbf] p-[10px]">Handlebar</td>
                    <td className="border border-[#bfbfbf] p-[10px]">Steering wheel</td>
                  </tr>

                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">Use Case</td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Light work, recreation
                    </td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Heavy work, hauling, commercial use
                    </td>
                  </tr>

                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">Cargo Capacity</td>
                    <td className="border border-[#bfbfbf] p-[10px]">Limited</td>
                    <td className="border border-[#bfbfbf] p-[10px]">Large cargo bed</td>
                  </tr>

                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">Safety</td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Minimal protection
                    </td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Roll cage, seat belts, enclosed cabin (optional)
                    </td>
                  </tr>

                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">Comfort</td>
                    <td className="border border-[#bfbfbf] p-[10px]">Basic</td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      More comfort + stability
                    </td>
                  </tr>

                  <tr>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Terrain Capability
                    </td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Agile, narrow trails
                    </td>
                    <td className="border border-[#bfbfbf] p-[10px]">
                      Heavy loads, rugged environments
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* <div className="pt-[5px] pb-[8px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-4">
                <div className="col-span-1">
                  <p className="text-center text-[#383838] text-[24px] pt-[3px] pb-[13px] kuunari-bold">
                    ATVs (All-Terrain Vehicles):
                  </p>
                  <p className="text-[16px] leading-[24px] text-[#A8A6A6] max-w-[483px] mx-auto">
                    Also known as quad bikes or four-wheelers, typically designed for a single rider who straddles the
                    seat, usually controlled with handlebars, like a motorcycle. Generally smaller and more manoeuvrable
                    than side-by-sides.  ATVs are  commonly used in farming, particularly for tasks like mustering livestock. They are subject to
                    specific safety regulations in New Zealand due to high accident rates.
                  </p>
                </div>
                <div className="col-span-1">
                  <p className="text-center text-[#383838] text-[24px] pt-[3px] pb-[13px] kuunari-bold ">
                    UTVs (Off-Road Utility Vehicle):
                  </p>
                  <p className="text-[16px] leading-[24px] text-[#A8A6A6] max-w-[483px] mx-auto">
                    A UTV is  a member of the side-by-side stable of vehicles, which have a side-by-side seating configuration and have a steering wheel and foot pedals, more like a car.  They are generally equipped with a larger cargo bed for hauling materials and have the ability to carry up to three passengers including the driver.  UTVs and side-by-sides are generally considered safer than ATVs due to their ROPS (roll over protection system) and seat belts.  They are principally used in agriculture, while UTVs have a much wider application.
                  </p>
                </div>
              </div>
             
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NZYouTube;
